import { useDialog } from './use-dialog'
import { createNameSpace } from '@el-plus/utils/bem'
import {
  EpSearchListPage,
  type SearchListPageInstance,
} from '@el-plus/components/search-list-page'
import type { DialogOptions } from './use-dialog'
import type { SearchListPageProps } from '@el-plus/components/search-list-page'
import { reactive, ref, toRaw,unref, useTemplateRef, nextTick } from 'vue'
const bem = createNameSpace('choose-dialog')
import { useLocale } from '@el-plus/hooks/use-locale'

type Options = {
  title?: string
  dialogProps?: DialogOptions
  multiple?: boolean
} & SearchListPageProps
export const useChooseDialog = (options: Options = {}) => {
  const { t } = useLocale()
  const { dialogProps, title, multiple, ...rest } = options
  const selections = ref([])
  const showSingleSelectionCol = !multiple
  const scopedSlots: DialogOptions['scopedSlots'] = {}
  if (!showSingleSelectionCol) {
    scopedSlots.footerPrepend = () => {
      return (
        <span class={bem.e('selected-count')}>
          {t('ep.chooseDialog.selected')}
          {selections.value.length}
          {t('ep.chooseDialog.unit')}
        </span>
      )
    }
  }
  const clearSelections = async () => {
    selections.value = []
    searchListPageRef.value?.tableRef?.clearSelection() // 清理表格选中
  }
  let searchListPageRef
  return useDialog({
    class: bem.b(),
    width: '80%',
    showFooter: !showSingleSelectionCol,
    scopedSlots,
    title,
    onConfirm: (resolve) => {
      resolve(JSON.parse(JSON.stringify(selections.value)))
      clearSelections()
    },
    onCancel: async (resolve) => {
      clearSelections()
      resolve()
    },
    render: ({ resolve }) => {
      if (!searchListPageRef) {
        searchListPageRef =
          useTemplateRef<SearchListPageInstance>('searchListPage')
      }

      const formData = rest.formData || reactive({})
      return (
        <EpSearchListPage
          ref="searchListPage"
          {...{
            showSelectionCol: multiple,
            showSingleSelectionCol,
            formData,
            ...rest,
            formProps: {
              col: 3,
              ...rest.formProps,
            },
            tableProps: {
              height: 300,
              ...rest.tableProps,
              onSelectionChange: (newSel) => {
                selections.value = newSel
              },
              onSingleSelectionChange: (newSel) => {
                selections.value = newSel
                resolve(toRaw(unref(selections)))
              },
            },
          }}
        />
      )
    },
    ...dialogProps,
  })
}
